import { ZfPill, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ProjectionScenario } from '../../../api/generated/client';
import { useGeneralSimulationSettings } from '../../../hooks/useGeneralSimulationSettings';

export const ScenarioSwitch: FunctionComponent = () => {
    const { t } = useTranslation();
    const { settings, patchSettings } = useGeneralSimulationSettings();

    const isDefaultScenario = settings?.scenario === 'DEFAULT';

    const changeScenario = (scenario: ProjectionScenario) => patchSettings({ scenario });

    return (
        <ZfStack direction="column" spacing="small">
            <ZfTypography variant="label-small" color="normal" style={{ marginLeft: 'var(--padding-left-xs)' }}>
                {t('projectionMethodLabel')}
            </ZfTypography>
            <ZfStack
                direction="row"
                spacing="small"
                alignment="center"
                style={{ marginLeft: 'var(--padding-left-md)', marginBottom: 'var(--padding-left-md)' }}
            >
                <ZfPill
                    size="medium"
                    variant={isDefaultScenario ? 'solid' : 'soft'}
                    color={isDefaultScenario ? 'primary' : 'neutral'}
                    onPillClick={() => changeScenario('DEFAULT')}
                >
                    {t('defaultScenario')}
                </ZfPill>
                <ZfPill
                    size="medium"
                    variant={isDefaultScenario ? 'soft' : 'solid'}
                    color={isDefaultScenario ? 'neutral' : 'primary'}
                    onPillClick={() => changeScenario('CUSTOM')}
                >
                    {t('customScenario')}
                </ZfPill>
            </ZfStack>
        </ZfStack>
    );
};
